<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >
      <Row type="flex" justify="center">
        <Col span="18">
          <FormItem label="日期" prop="recordDate">
            <DatePicker
              class="widK"
              type="date"
              :disabled="action == 'detail' ? true : false"
              v-model="formValidate.recordDate"
              placeholder="选择日期"
              format="yyyy-MM-dd"
            ></DatePicker>
          </FormItem>
          <FormItem label="姓名" prop="name">
            <Input
              class="widK"
              :disabled="action == 'detail' ? true : false"
              v-model.trim="formValidate.name"
              placeholder="姓名"
            ></Input>
          </FormItem>
          <FormItem label="身份证号码" prop="idCard">
            <Input
              class="widK"
              :disabled="action == 'detail' ? true : false"
              v-model.trim="formValidate.idCard"
              placeholder="身份证号码"
            ></Input>
          </FormItem>
          <FormItem label="参与大类" prop="categoryList">
            <CheckboxGroup v-model="formValidate.categoryList" @on-change="categoryChange">
              <Checkbox
                v-for="item in categoryList"
                :key="item.value"
                :label="item.label"
                >{{ item.label }}</Checkbox
              >
            </CheckboxGroup>
          </FormItem>
          <FormItem label="具体事项" prop="detail">
            <Input
              class="widK"
              type="textarea"
              :disabled="action == 'detail' ? true : false"
              v-model.trim="formValidate.detail"
              placeholder="具体事项"
            ></Input>
          </FormItem>
          <FormItem label="积分" prop="branch">
            <Input
              class="widK"
              :disabled="action == 'detail' ? true : false"
              v-model.trim="formValidate.branch"
              placeholder="积分"
            ></Input>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input
              class="widK"
              type="textarea"
              :disabled="action == 'detail' ? true : false"
              v-model.trim="formValidate.remark"
              placeholder="备注"
            ></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Button type="primary" v-if="display" @click="submit()">确定</Button>
        <Button
          type="default"
          v-if="display"
          style="margin: 0 16px"
          @click="handleReset"
          >重置</Button
        >
        <Button type="default" @click="back">返回</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
import common from "@/libs/common.js";

export default {
  name: "integralPeopleItemAdd",

  data() {
    const validateId = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写身份证号码"));
      } else {
        if (!common.checkIdCard(value)) {
          callback(new Error("请填写正确格式的身份证号码"));
        } else {
          callback();
        }
      }
    };
    const validateNum = (rule, value, callback) => {
      let numberReg = /^-?\d+(\.\d+)?$/;
      if (value !== "") {
        if (!numberReg.test(value)) {
          callback(new Error("请输入数字"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入值"));
      }
    };

    return {
      display: true,
      categoryList: [
        { label: "乡风文明", value: "乡风文明" },
        { label: "文体健康", value: "文体健康" },
        { label: "矛盾调解", value: "矛盾调解" },
        { label: "建言献策", value: "建言献策" },
        { label: "基层治理", value: "基层治理" },
        { label: "人居环境", value: "人居环境" },
      ],
      formValidate: {
        categoryList: [],
      },
      ruleValidate: {
        recordDate: [
          { required: true, type: "date", message: "请选择日期", trigger: "change" },
        ],
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        idCard: [{ required: true, validator: validateId }],
        category: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请至少选择一个参与大类",
            trigger: "change",
          },
        ],
        branch: [{ required: true, validator: validateNum }],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$byStoreHas(this.$route.name)) {
        this.action = this.$byStoreGet(this.$route.name).action;
        this.id = this.$byStoreGet(this.$route.name).id || "";
      } else {
        this.$router.push({ name: "404" });
      }
      if (this.action == "edit" || this.action == "detail") {
        this.getParams(this.id);
        if (this.action == "detail") {
          this.display = false;
        }
      }
    },
    categoryChange() {
      this.$refs.formValidate.validateField("category");
    },
    /**
     * @description 获取数据
     */
    getParams(id) {
      this.$http
        .get("/api/tIntegralPeopleItem/get", {
          params: { id: id },
        })
        .then((res) => {
          let data = res.data.data;
          if (data.recordDate) {
            data.recordDate = new Date(data.recordDate);
          }
          data.categoryList = data.category ? data.category.split("、") : [];
          this.formValidate = data;
        });
    },
    /**
     * @description 提交
     */
    submit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.formValidate));
          params.category = params.categoryList
            ? params.categoryList.join("、")
            : "";
          delete params.categoryList;
          if (params.recordDate && typeof params.recordDate !== "string") {
            var year = params.recordDate.getFullYear();
            var month = params.recordDate.getMonth() + 1;
            if (month < 10) month = "0" + month;
            var day = params.recordDate.getDate();
            if (day < 10) day = "0" + day;
            params.recordDate = year + "-" + month + "-" + day;
          }
          let httpAction =
            this.action == "edit" ? "update" : "save";
          this.$http
            .post("/api/tIntegralPeopleItem/" + httpAction, params)
            .then((res) => {
              if (res.data.code == 200) {
                this.$Message.success("保存成功");
                this.back();
              }
            })
            .catch(() => {
              this.$Message.error("保存失败");
            });
        } else {
          this.$Message.error("请检查表单信息");
        }
      });
    },
    /**
     * @description 表单重置
     */
    handleReset() {
      this.$refs.formValidate.resetFields();
    },
    /**
     * @description 返回
     */
    back() {
      this.$store.commit("app/closePage", {
        vm: this,
        fromName: this.$route.name,
        toName: "integralPeopleItem",
      });
    },
  },
};
</script>

<style scoped>
#content {
  width: 100%;
}
.disabled {
  pointer-events: none;
}
</style>
